import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from "@angular/common/http";
import { catchError, throwError } from "rxjs";
import { inject } from "@angular/core";
import { ENV_FILE_TOKEN, InitService } from "gast-common-ng2";
import { TranslateService } from "@ngx-translate/core";
import { PortalQueryParams } from "../constants";

/**
 * Performs a redirect to portal account login to re login in case of the error response with code: {@link HttpStatusCode#Unauthorized}
 *
 * @author Mateusz Warzyc
 * @param req request
 * @param next request handler
 */
export const portalHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const envConfig = inject(ENV_FILE_TOKEN);
  const initService = inject(InitService);
  const translateService = inject(TranslateService);

  const provideRedirectUrl = (): string => {
    const currentUrl = new URL(window.location.href);
    setLandSearchParam(currentUrl);
    setProductIdParam(currentUrl);
    return `${envConfig.accountPortalUrl}login?redirect=${currentUrl.toString()}`;
  };

  const setLandSearchParam = (currentUrl: URL): void => {
    const resolvedLang: string | null =
      currentUrl.searchParams.get(PortalQueryParams.LANGUAGE_CODE) || translateService.currentLang;
    if (!!resolvedLang && resolvedLang.length > 0) {
      //use set to override the existing lang and delete other that may exist
      currentUrl.searchParams.set(PortalQueryParams.LANGUAGE_CODE, resolvedLang.toLowerCase());
    } else {
      currentUrl.searchParams.delete(PortalQueryParams.LANGUAGE_CODE);
    }
  };

  const setProductIdParam = (currentUrl: URL): void => {
    const resolvedProduct: string | null =
      currentUrl.searchParams.get(PortalQueryParams.PRODUCT_ID) || initService.getProductFromLocalStorage();
    if (!!resolvedProduct && resolvedProduct.length > 0) {
      //use set to override the existing product and delete other that may exist
      currentUrl.searchParams.set(PortalQueryParams.PRODUCT_ID, resolvedProduct.toLowerCase());
    } else {
      currentUrl.searchParams.delete(PortalQueryParams.PRODUCT_ID);
    }
  };

  return next(req).pipe(
    catchError((response: HttpErrorResponse) => {
      if (HttpStatusCode.Unauthorized === response.status) {
        window.location.href = provideRedirectUrl();
      }
      return throwError(() => response);
    })
  );
};
